// Third-party scripts/extensions that don't catch their own network/load failures, or whose
// errors we can never attribute to app code — not real bugs. Synced with platform-app's
// core/monitoring/src/MonitoringProvider.tsx absPathBlock; some entries (e.g. Clarity, Intercom,
// Google Maps, LaunchDarkly) have no known auth-app integration path but are kept for parity.
export const THIRD_PARTY_NOISE_PATTERNS = [
  'analytics.melio.com',
  'data-api.melio.com',
  'api-analytics.melio.com',
  'api.segment.io',
  'snap.licdn.com',
  'px.ads.linkedin.com',
  'sdk.iad-05.braze.com',
  'api.amplitude.com',
  'analytics.tiktok.com',
  'h.clarity.ms',
  'p.clarity.ms',
  'js.intercomcdn.com',
  'maps.googleapis.com',
  'launchdarkly-js-sdk',
  'googletagmanager.com',
  'cdn.nmgassets.com',
  'chrome-extension',
  'safari-extension',
  'safari-web-extension',
  'blob:', // extensions (e.g. password managers) injecting content scripts via blob: to sidestep CSP
  'dispatchToBridge', // Facebook/Instagram in-app browser's native-bridge shim (login-field-detection variant)
];

// Some Segment-originated console errors carry no URL or stack at all (Safari drops both for
// these), so they can only be matched by their fixed, known message text.
export const THIRD_PARTY_NOISE_MESSAGE_PATTERNS = [
  'Error sending segment performance metrics',
  'Failed to load Analytics.js',
  'window.webkit.messageHandlers', // Facebook/Instagram in-app browser's own native-bridge shim, not our code
];

// CefSharp bot errors triggered by automated systems (e.g. Outlook Safe Links prefetching/scanning
// links) — not real users. Reference: https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/
export const CEFSHARP_BOT_ERROR_PATTERN = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;

// A dynamically-imported JS chunk whose load gets aborted mid-flight by page navigation — e.g. the
// SSO callback flow redirects onward almost immediately after processing the response, killing any
// lazy-loaded chunk request still in progress. Not an app bug, just the module loader's version of
// the aborted-fetch case handled by the status_code:0 check in Logger.ts's beforeSend.
export const MODULE_IMPORT_ABORT_MESSAGE_PATTERNS = [
  'Importing a module script failed.', // Safari
  'error loading dynamically imported module', // Firefox
  'Failed to fetch dynamically imported module', // Chrome
];

// Firefox's bare fetch-failure placeholder (Chrome/Safari's equivalents are intentionally excluded — see PR).
export const BARE_NETWORK_ERROR_MESSAGE_PATTERNS = ['NetworkError when attempting to fetch resource.'];
